/**
 * Guardian shell selection (Phase 12, plan §4.1).
 *
 * A guardian (role patientfamily) holds only portal:read plus the self-profile permissions.
 * Anyone with portal:read and no other (staff) permission gets the guardian shell instead of
 * the staff dashboard. The backend enforces the same split (every staff route 403s for
 * guardians), so this only picks the UI.
 */

export const PORTAL_READ_PERMISSION = 'portal:read';

/** Permissions a guardian may hold that do not make them staff. */
const GUARDIAN_PERMISSIONS: ReadonlySet<string> = new Set([
  PORTAL_READ_PERMISSION,
  'user:profile:read',
  'user:profile:write',
]);

/** True when the permission set is a guardian's: portal:read and nothing staff-only. */
export function isGuardianOnly(permissions: readonly string[] | undefined | null): boolean {
  if (!permissions || !permissions.includes(PORTAL_READ_PERMISSION)) return false;
  return permissions.every((permission) => GUARDIAN_PERMISSIONS.has(permission));
}
